module.exports = __webpack_public_path__ + "img/miladcontrole.b0affd0f.jpg";